import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, APP_PREFIX_PATH } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token, user } = useSelector(state => state.auth)
	// Check if current user is Virtual PA - handle both boolean true and string "true"
	const isVirtualPa = user?.role?.virtualPa === true || user?.role?.virtualPa === "true";
	// For Virtual PA users, redirect to customers list, otherwise use default entry
	const redirectPath = token && isVirtualPa ? `${APP_PREFIX_PATH}/customers` : AUTHENTICATED_ENTRY;
  
	return token ? <Navigate to={redirectPath} /> : <Outlet/>
}

export default PublicRoute